<template>
  <div class="container">
    <div class="oval"></div>
    <div class="oval-text">
      <div class="oval-text-data">
        <span class="data-numbers">{{ divisor }}/{{ dividendo }}</span>
      </div>
      <div class="oval-text-label capitalize-first">
        <span class="data-label">{{ label }}</span>
      </div>
    </div>
    <div class="chart">
      <apexchart type="radialBar" height="220" :options="chartOptions" :series="series"></apexchart>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

import VueApexCharts from "vue-apexcharts";

Vue.use(VueApexCharts);

Vue.component("apexchart", VueApexCharts);
@Component
export default class RadialBar extends Vue {
  @Prop({ required: true })
  divisor!: number;
  @Prop({ required: true })
  dividendo!: number;
  @Prop({ required: true })
  label!: string;

  series = [(this.divisor / this.dividendo) * 100];
  chartOptions = {
    chart: {
      type: "radialBar",
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      radialBar: {
        startAngle: 0,
        endAngle: 360,
        hollow: {
          margin: 0,
          size: "90%",
          //background: '#fff',
          //image: undefined,
          imageOffsetX: 0,
          imageOffsetY: 0,
          position: "front",
          dropShadow: {
            enabled: false,
          },
        },
        track: {
          strokeWidth: "67%",
          margin: 0, // margin is in pixels
          dropShadow: {
            enabled: false,
          },
        },
        dataLabels: {
          show: false,
        },
      },
    },
    colors: ["#ffd102"],
    fill: {
      type: "gradient",
      gradient: {
        shade: "dark",
        type: "horizontal",
        gradientToColors: ["#4c4c4c"],
        inverseColors: true,
        opacityFrom: 1,
        opacityTo: 1,
        stops: [0, 100],
      },
    },
    stroke: {
      lineCap: "round",
    },
    labels: ["Percent"],
  };
}
</script>

<style lang="scss" scoped>
.oval {
  width: 135px;
  height: 135px;
  background-color: #f2f2f2;
  border-radius: 50%;
  position: absolute;
  margin-left: 24px;
  margin-top: 31px;
}
.container {
  width: 210px;
  height: 210px;
  margin: -20px;
  position: initial;
}
.oval-text {
  position: absolute;
  z-index: 3;
  color: #1e1e1e;
  padding-top: 75px;
  margin-left: 45px;
}
.oval-text-data {
  font-family: Roboto, Arial, Helvetica, sans-serif;
  font-size: 32px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.5;
  letter-spacing: 0.29px;
  text-align: center;
  color: #5d6770;
  width: 90px;
}
.oval-text-label {
  padding-top: 15px;
  font-family: Roboto, Arial, Helvetica, sans-serif;
  font-size: 22px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.09;
  letter-spacing: 0.2px;
  text-align: center;
  position: relative;
  width: 110px;
  margin-left: -10px;
  color: var(--secundario-prosegur-oscuro);
}
</style>
